import store from '../../store';
import {setQuotes} from '../../actions/roomsFunctions';
import workspace from '../../bvcomponents/sqft/components/canvas/core/workspace';
import {prepareSQFTDataCore} from '../../bvcomponents/sqft/components/canvas/core/workspace/workspaceDataMapper';
import {getActiveSQFTQuoteIndexFromState} from '../../bvcomponents/sqft/helpers/sqftQuoteIndexHelper';

function isSqftRecoveryContext(state) {
  const sqftState = state.sqftState || {};
  const locationHash = window.location.hash || '';

  return sqftState.isSquareFootageEnabled
    || sqftState.isSQFTInVisualizer
    || /^#\/sqft(?:$|[/?-])/.test(locationHash);
}

// Preserve the mutable calculator workspace before recovery UI saves the quote.
export function preserveCurrentSqftDataForRecovery() {
  try {
    const state = store.getState();

    if (!isSqftRecoveryContext(state) || !workspace.isInitialized || workspace.isEmpty()) {
      return false;
    }

    const quoteIndex = getActiveSQFTQuoteIndexFromState(state);
    const quotes = state.quotesState && state.quotesState.quotes;

    if (!Array.isArray(quotes) || !quotes[quoteIndex]) {
      return false;
    }

    const sqftCalcData = prepareSQFTDataCore();
    const updatedQuotes = quotes.map((quote, index) => index === quoteIndex
      ? {
        ...quote,
        sqFtCalcData: sqftCalcData,
      }
      : quote);

    store.dispatch(setQuotes(updatedQuotes));
    return true;
  } catch (error) {
    // Recovery must remain available even if the damaged workspace cannot export.
    console.error('Failed to preserve SQFT data for fatal-error recovery', error);
    return false;
  }
}
